// extracted by mini-css-extract-plugin
module.exports = {"reloadButton":"gYpwl","content":"_2lW-H","textContainer":"TXAYC","textTitle":"_3pF6C","text":"_1HYNg"};